import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@tom-ui/planning'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import _ from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { PieItem } from '../components/PieGraph'
import { VisitCard } from '../components/VisitCard'
import {
  getContainerSummaryFromVisits,
  getDefaultVisitStatusForPieChart,
  isDateBetweenFromAndTo,
  updateVisitDashabordsByStatus,
} from '../helpers/helper'

interface Props {
  currentDate: Date
}
export const VesselVisitWidget = observer(({ currentDate }: Props) => {
  const { t } = useTranslate()
  const { vesselVisitItemStore } = usePlanningStore()
  const theme = useMinimalsTheme()

  const getVisits = () => {
    return _(vesselVisitItemStore.elements)
      .filter(
        visit =>
          visit.status === 'InOperation' ||
          isDateBetweenFromAndTo(currentDate, visit.arrival, visit.departure),
      )
      .value()
  }

  const graphItems = computed(() => {
    const items: PieItem[] = getDefaultVisitStatusForPieChart(theme, t)

    getVisits().forEach(visit => {
      updateVisitDashabordsByStatus(items, visit.status)
    })

    return items.filter(x => x.value > 0)
  }).get()

  const containersSummary = computed(() => {
    return getContainerSummaryFromVisits(getVisits())
  }).get()

  return (
    <VisitCard
      title={t('vessels', 'Vessels')}
      seeMorePath={PATHS.visits.vesselVisits.url}
      graphItems={graphItems}
      containersIn={containersSummary.summaryIn}
      containersOut={containersSummary.summaryOut}
      dataCy='vessel-widget-card'
    />
  )
})
